import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { getUsageSummary } from '../api';

export default function Overview({ dimension }) {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    setLoading(true);
    getUsageSummary(dimension)
      .then(r => { setData(r.data); setError(null); })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [dimension]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error)   return <div className="error">Error: {error}</div>;

  const customers = data.customers || [];
  const totalOrders = customers.reduce((s, c) => s + (c.total_orders || 0), 0);
  const totalTasks  = customers.reduce((s, c) => s + (c.total_tasks  || 0), 0);
  const active      = customers.filter(c => c.total_orders > 0).length;

  const top8 = [...customers]
    .sort((a, b) => (b.total_orders || 0) - (a.total_orders || 0))
    .slice(0, 8)
    .map(c => ({ name: c.cust_code, orders: c.total_orders || 0, tasks: c.total_tasks || 0 }));

  return (
    <>
      <div className="metrics">
        <div className="metric">
          <div className="metric-label">Total samples</div>
          <div className="metric-value">{totalOrders.toLocaleString()}</div>
          <div className="metric-sub">all active customers</div>
        </div>
        <div className="metric">
          <div className="metric-label">Total tests</div>
          <div className="metric-value">{totalTasks.toLocaleString()}</div>
          <div className="metric-sub">all active customers</div>
        </div>
        <div className="metric">
          <div className="metric-label">Reporting customers</div>
          <div className="metric-value">{active}</div>
          <div className="metric-sub">with data in period</div>
        </div>
      </div>

      <div className="two-col">
        <div className="card">
          <div className="card-header">
            <div className="card-title">Top 8 customers by samples</div>
            <div className="legend">
              <span><span className="legend-dot" style={{background:'#378ADD'}}></span>Samples</span>
              <span><span className="legend-dot" style={{background:'#1D9E75'}}></span>Tests</span>
            </div>
          </div>
          <div className="card-body">
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={top8} margin={{top:4,right:4,left:0,bottom:4}}>
                <XAxis dataKey="name" tick={{fontSize:11}} />
                <YAxis tick={{fontSize:11}} tickFormatter={v => v >= 1000 ? `${(v/1000).toFixed(0)}k` : v} />
                <Tooltip formatter={v => v.toLocaleString()} />
                <Bar dataKey="orders" name="Samples" fill="#378ADD" radius={[2,2,0,0]} />
                <Bar dataKey="tasks"  name="Tests"   fill="#1D9E75" radius={[2,2,0,0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">All customers</div></div>
          <div style={{maxHeight:320, overflowY:'auto'}}>
            <table>
              <thead>
                <tr><th>Customer</th><th>Location</th><th>Samples</th><th>Tests</th></tr>
              </thead>
              <tbody>
                {customers.map(c => (
                  <tr key={c.cust_code}>
                    <td style={{fontWeight:500}}>{c.cust_name}</td>
                    <td style={{color:'#666'}}>{c.location}</td>
                    <td>{(c.total_orders || 0).toLocaleString()}</td>
                    <td>{(c.total_tasks  || 0).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
